import { render } from "./crfView.vue?vue&type=template&id=7a888f04&scoped=true"
import script from "./crfView.js?vue&type=script&lang=js"
export * from "./crfView.js?vue&type=script&lang=js"

import "./crfView.vue?vue&type=style&index=0&id=7a888f04&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a888f04"]])

export default __exports__